import { IndividualCategoryResultContract } from '.';

export interface CirilCategoryResultContract {
  algorithmic_thinking: IndividualCategoryResultContract;
}
